import React, { useState, useEffect } from "react";
import axios from "axios";

function Test() {
  const [catFact, setCatFact] = useState("");

  useEffect(() => {
    axios.get("https://catfact.ninja/fact").then((res) => {
      setCatFact(res.data.fact);
    });
  }, []);

  return (
    <>
      <div className="container my-5">
        <p>{catFact}</p>

        <div className="row">
          <div className="col-md-2">
            <div className="card">
              <div className="card-body">Test</div>
            </div>
          </div>

          <div className="col-md-10">
            <div className="row">

              <div className="col-md-2">
                <div className="card">
                  <div className="card-body">
                    <p>Date: 2024-03-22</p>
                    <p>Icon: snow</p>
                    <p>0.4°/25.2°</p>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="card">
                  <div className="card-body">
                    <p>Date: 2024-03-22</p>
                    <p>Icon: snow</p>
                    <p>0.4°/25.2°</p>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="card">
                  <div className="card-body">
                    <p>Date: 2024-03-22</p>
                    <p>Icon: snow</p>
                    <p>0.4°/25.2°</p>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="card">
                  <div className="card-body">
                    <p>Date: 2024-03-22</p>
                    <p>Icon: snow</p>
                    <p>0.4°/25.2°</p>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="card">
                  <div className="card-body">
                    <p>Date: 2024-03-22</p>
                    <p>Icon: snow</p>
                    <p>0.4°/25.2°</p>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
        
      </div>
    </>
  );
}

export default Test;
